export default __webpack_public_path__ + "static/media/Mercurio.a7105a56.png";